import React, { useState, useEffect } from "react";
import { useChecklist } from "../context/ChecklistContext";
import config from "../config";
import { getChecklistStatus } from "../utils/checklistUtils";
import topicReadImg from '../assets/images/icon-topic-read.svg'; 
import markTopicReadImg from '../assets/images/icon-mark-topic-complete.svg'; 
import nextTopicImg from '../assets/images/icon-next-topic.svg'; 

interface MarkTopicAsReadButtonProps {
  checklistId?: string;
}

const MarkTopicAsReadButton: React.FC<MarkTopicAsReadButtonProps> = ({ checklistId }) => {
  const { checklistTopicStatus, markChecklistAsReadContext, checklistData } = useChecklist();
  const [isRead, setIsRead] = useState(false);
  const [nextChecklist, setNextChecklist] = useState<string | null>(null);
  const [isLastChecklist, setIsLastChecklist] = useState(false);
  const [isLoading, setIsLoading] = useState(false); 

  useEffect(() => {
    if (checklistId) {
      const initialStatus = getChecklistStatus(checklistId, checklistTopicStatus);
      setIsRead(initialStatus === "Completed");

      // Find the current checklist index
      const currentIndex = checklistData.findIndex(item => item.checklistId.toString() === checklistId);
      if (currentIndex !== -1 && currentIndex < checklistData.length - 1) {
        // Set the next checklist URL
        setNextChecklist(`/k12-checklist/${checklistData[currentIndex + 1].checklistName.toLowerCase().replace(/_/g, "-")}`);
        setIsLastChecklist(false);
      } else {
        // Last checklist item: Show "Next Section" instead of "Next Topic"
        setNextChecklist("/school-prep-checklist");
        setIsLastChecklist(true);
      }
    }
  }, [checklistId, checklistTopicStatus, checklistData]);

  
  const handleToggleReadStatus = async () => {
    if (!checklistId) return;
    try {
      setIsLoading(true); // Disabling the button while API res is processing

      const numericChecklistId = Number(checklistId); // Convert checklistId to number
      // console.log("checklistId", isRead);
      
      const newStatus = !isRead ? "true" : "false"; // Convert to string
      setIsRead(newStatus === "true");
  
      await markChecklistAsReadContext(numericChecklistId.toString(), newStatus); // Convert back to string if needed
  
      // console.log("Checklist newStatus:", numericChecklistId, newStatus);
    } catch (error) {
      console.error("Failed to update topic status", error);
    } finally {
      setIsLoading(false); // Re-enable button after API call completes
    }
  };
  
  

  return (
    <div className="row bottom-links-navigation">
      <div className="col-12 d-flex justify-content-center justify-content-md-between align-items-center flex-wrap gap-3">
        {/* Mark as Read Button */}
        <span
          onClick={handleToggleReadStatus}
          className={`button-mark-completed heading-4 text-white ${isRead ? "read" : ""}`}
          style={{ 
            cursor: isLoading ? "not-allowed" : "pointer", 
            opacity: isLoading ? 0.7 : 1 
          }}
        >
          <img
            src={isRead ? topicReadImg : markTopicReadImg}
            alt={isRead ? "Topic Read!" : "Mark Topic Read"}
          />
          {isLoading ? "Updating..." : isRead ? "Topic Read!" : "Mark Topic Read"}
        </span>

        {/* Next Topic link */}
        {nextChecklist && (
          <span className="heading-4 next">
            <a className="text-color-blue-4" href={nextChecklist}>
              Next Topic
              <img src={nextTopicImg} alt="Next" />
              &nbsp;
            </a>
          </span>
        )}
      </div>
    </div>
  );
};

export default MarkTopicAsReadButton;
